// On mobile the filter panel is a popup - auto-submitting per checkbox would reload the page and
// re-close it before a second box could be checked. So changes stage there until "Áp dụng" submits.
const MOBILE_QUERY = '(max-width: 675px)';

document.body.addEventListener('change', (event) => {
	const input = event.target.closest('.c-collection__check-input');
	if (!input || !input.form) {
		return;
	}

	if (!window.matchMedia(MOBILE_QUERY).matches) {
		input.form.submit();
	}
});
